//TODO: 6월 21일 라이브버전 주석처리

// import { useLocation } from 'react-router-dom'

// import Banner from '~/features/home/components/Banner'
import EventInfo from '~/features/home/components/EventInfo'
import MainIntro from '~/features/home/components/MainIntro'
// import Participation from '~/features/home/components/Participation'
import PerformanceInfo from '~/features/home/components/PerformanceInfo'
import SNS from '~/features/home/components/SNS'
import { useMainContents } from '~/features/home/queries/useMainInfo'
import LoadingScreen from '~/shared/components/loading/LoadingScreen'

function HomePage() {
  // const location = useLocation()
  // const pathname = location.pathname

  const { isLoading, data } = useMainContents()

  const { ongoing_event: ongoingEvent, contents_dic: contentsDic } = data! || {}

  return (
    <>
      {isLoading ? (
        <LoadingScreen />
      ) : (
        <>
          {/* {pathname === '/' && <Banner bannerInfo={contentsDic?.BANNER} />} */}
          <MainIntro ongoingEvent={ongoingEvent} />
          <PerformanceInfo inviteInfo={contentsDic?.INVITE} />
          <EventInfo eventInfo={contentsDic.VIDEO} />
          <SNS />
          {/* <Participation /> */}
        </>
      )}
    </>
  )
}

export default HomePage
